export default "__VITE_ASSET__cf0daf90__"